var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13h-3.9v-2.6h3.9a3.9 3.9 0 0 0 0-7.8h-3.9V0h3.9a6.5 6.5 0 0 1 0 13Zm-9.1 0H6.5a6.5 6.5 0 1 1 0-13h3.9v2.6H6.5a3.9 3.9 0 0 0 0 7.8h3.9V13Zm9.1-5.2h-13V5.2h13v2.6Z",
    fill: "#333"
  })));
};
export default SvgLink;